document.addEventListener("DOMContentLoaded", () => {
  const section = document.getElementById("shopify-section-header-revamp");

  // This page may be using a different header section
  // such as header-revamp-template on wholesale pages.
  // If the regular header section is not present,
  // do not run this script.
  if (!section) return;

  const header = section.querySelector(".header-revamp");
  const menuButton = section.querySelector("#mobile-menu-button");
  const drawer = section.querySelector(".header-revamp-drawer");
  const cartCountEl = section.querySelector("#header-revamp-cart-count");
  const navLinks = section.querySelectorAll(".header-revamp-drawer-nav-link");
  const menuItems = section.querySelectorAll(".header-revamp-menu > ul > li");

  // Sticky Header
  let lastScrollTop =
    window.pageYOffset ||
    document.documentElement.scrollTop;

  const threshold = 70;

  if (header) {
    window.addEventListener(
      "scroll",
      () => {
        const currentScrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop;

        if (currentScrollTop > threshold) {
          section.classList.toggle(
            "header-revamp-hidden",
            currentScrollTop > lastScrollTop
          );
        } else {
          section.classList.remove(
            "header-revamp-hidden"
          );
        }

        lastScrollTop =
          Math.max(
            currentScrollTop,
            0
          );
      },
      {
        passive: true
      }
    );

    // Maintain layout spacing
    if (drawer) {
      drawer.style.height =
        `calc(100vh - ${header.offsetHeight}px)`;

      drawer.style.top =
        `${header.offsetHeight}px`;
    }
  }

  // Helper: reset all hrmm roots back to main
  function resetMobileNavToMain(
    noAnimation = false
  ) {
    section
      .querySelectorAll(".hrmm-root")
      .forEach(root => {
        try {
          if (
            typeof root.resetHrmm ===
            "function"
          ) {
            root.resetHrmm(
              noAnimation
            );
          } else {
            // Fallback: attempt to remove active classes quickly
            const active =
              root.querySelector(
                ".hrmm-slide.active"
              );

            const main =
              root.querySelector(
                '.hrmm-slide[data-slide-id="main"]'
              );

            if (
              active &&
              main &&
              active !== main
            ) {
              active.classList.remove(
                "active",
                "enter-left",
                "enter-right",
                "exit-left",
                "exit-right"
              );

              main.classList.add(
                "active"
              );
            }
          }
        } catch (err) {
          console.warn(
            "resetMobileNavToMain error",
            err
          );
        }
      });
  }

  // Mobile Drawer Toggle
  if (
    menuButton &&
    drawer
  ) {
    menuButton.addEventListener(
      "click",
      () => {
        const isNowOpen =
          drawer.classList.toggle(
            "header-revamp-drawer-open"
          );

        menuButton.classList.toggle(
          "active"
        );

        document.body.classList.toggle(
          "no-scroll"
        );

        if (!isNowOpen) {
          resetMobileNavToMain(
            true
          );
        }
      }
    );

    // Observe drawer class changes as a fallback
    const mo =
      new MutationObserver(
        mutations => {
          for (const mutation of mutations) {
            if (
              mutation.attributeName ===
              "class"
            ) {
              const isOpen =
                drawer.classList.contains(
                  "header-revamp-drawer-open"
                );

              if (!isOpen) {
                resetMobileNavToMain(
                  true
                );
              }
            }
          }
        }
      );

    mo.observe(
      drawer,
      {
        attributes: true
      }
    );
  }

  // Hover Menu Expansion
  menuItems.forEach(item => {
    const block =
      item.querySelector(
        ".header_revamp-mega-menu"
      );

    if (block) {
      item.addEventListener(
        "mouseenter",
        () => {
          block.style.height =
            `${block.scrollHeight}px`;
        }
      );

      item.addEventListener(
        "mouseleave",
        () => {
          block.style.height =
            `${block.scrollHeight}px`;

          requestAnimationFrame(
            () => {
              block.style.height =
                "0px";
            }
          );
        }
      );
    }
  });

  // Mobile Nav Submenu Toggle
  navLinks.forEach(link => {
    link.addEventListener(
      "click",
      function () {
        const parentLi =
          this.closest("li");

        const submenu =
          this.nextElementSibling;

        if (
          !parentLi ||
          !submenu?.classList.contains(
            "header-revamp-drawer-nav-submenu"
          )
        ) {
          return;
        }

        // Close other open submenus
        parentLi.parentElement
          .querySelectorAll(
            ".header-revamp-drawer-nav-submenu.active"
          )
          .forEach(el => {
            if (
              el !== submenu
            ) {
              el.classList.remove(
                "active"
              );
            }
          });

        parentLi.parentElement
          .querySelectorAll(
            "li.active"
          )
          .forEach(li => {
            if (
              li !== parentLi
            ) {
              li.classList.remove(
                "active"
              );
            }
          });

        submenu.classList.toggle(
          "active"
        );

        parentLi.classList.toggle(
          "active"
        );
      }
    );
  });

  // Cart Count Update via Rebuy
  function updateCartCount(
    cart
  ) {
    if (
      cartCountEl &&
      cart?.item_count !==
        undefined
    ) {
      cartCountEl.textContent =
        cart.item_count;

      if (
        cart.item_count > 0
      ) {
        cartCountEl.classList.remove(
          "hide"
        );
      } else {
        cartCountEl.classList.add(
          "hide"
        );
      }
    }
  }

  document.addEventListener(
    "rebuy:cart.ready",
    event => {
      updateCartCount(
        event.detail?.cart
      );
    }
  );

  document.addEventListener(
    "rebuy:cart.change",
    event => {
      updateCartCount(
        event.detail?.cart
      );
    }
  );
});